import { createReducer } from '@mews/framework';
import { SIDEBAR_OPENED, ATTRIBUTE_ID_SELECTED, SIDEBAR_CLOSED, HIGHLIGHTED_CELL_RANGE_SET } from '../actions';

const INITIAL_STATE = {
    highlightedCellRange: {},
    selectedAttributeId: null,
    opened: null,
};

const sidebarReducer = createReducer(INITIAL_STATE, {
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [SIDEBAR_OPENED]: (state, sidebarFormName) => ({
        ...state,
        opened: sidebarFormName,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [HIGHLIGHTED_CELL_RANGE_SET]: (state, highlightedCellRange) => ({
        ...state,
        highlightedCellRange,
    }),
    // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
    [ATTRIBUTE_ID_SELECTED]: (state, attributeId) => ({
        ...state,
        selectedAttributeId: attributeId,
    }),
    [SIDEBAR_CLOSED]: () => INITIAL_STATE,
});

export default sidebarReducer;
